import React from 'react';
import OrganizationStore from '../stores/OrganizationStore';
import OrganizationConstants from '../constants/OrganizationConstants';
import OrganizationActions from '../actions/OrganizationActions';
import * as Inovx from '@shared';

var SystemActions = Inovx.Shared.System.Actions;
var SystemStore = Inovx.Shared.System.Store;
var ListHelper = Inovx.Shared.Common.ListHelper;

var InovxControls = Inovx.Shared.Controls;

declare var InovxLoader: any;

const ORGANIZATION_HIERARCHY = 'Hierarchy';

interface OrganizationAccessRightFormProps {
}

interface OrganizationAccessRightFormState {
    parent?: IOrganizationBaseDetail;
    organization?: IItemDataDetail;
    isActionInProgress?: boolean;
    actionInProgressMsg?: string;
    allRoles: IOrganizationRole[];
}

function getActionInProgress(): boolean {
    return SystemStore.isActionInProgress(OrganizationConstants.ORGANIZATION_EDIT);
}

var _actionInProgressMsg: string;
function getFormState(): OrganizationAccessRightFormState {
    return {
        parent: OrganizationStore.getCurrentParent(),
        organization: OrganizationStore.getEditOrganization(),
        isActionInProgress: getActionInProgress(),
        actionInProgressMsg: _actionInProgressMsg,
        allRoles: OrganizationStore.getAllRoles()
    };
}

class OrganizationAccessRightForm extends React.Component<OrganizationAccessRightFormProps, OrganizationAccessRightFormState> {

    constructor(props: OrganizationAccessRightFormProps) {
        super(props);

        this.state = getFormState();
    }

    private _onChange = (event: any) => {
        OrganizationActions.update(event.target.name, event.target.value);
    }

    private _loadState = () => {
        this.setState(getFormState());
    }

    private _systemChange = () => {
        this.setState({
            isActionInProgress: getActionInProgress()
        } as any);
    }

    private _saveOrganization = () => {

        OrganizationActions.edit(this.state.parent);
        this.setState({ actionInProgressMsg: InovxLoader.t('organization:form.saving') } as any);
    }

    private _cancel = () => {
        OrganizationActions.endEdit();
    }

    private _isEmptyOrNull = (value: string) => {
        return value && value.length > 0;
    }

    private _validateOrganization = () => {
        var form: any = this.refs["name"];
        if (form.isValid(this._isEmptyOrNull)) {
            return true;
        }
        return false;
    }

    private _checkForUnsavedChanges = (event: any) => {
        if (OrganizationStore.getHasChanges()) {
            event.returnValue = InovxLoader.t('common:msgBox.browserSaveChanges');
        };
    }

    private _validateRemove = (selectedRoles: IAssignedRole[]) => {
        for (var i = 0; i < selectedRoles.length; i++) {
            var role = selectedRoles[i];
            if (role.Inherited !== undefined && role.Inherited) {
                var messageObject = {
                    message: InovxLoader.t('organization:error.inheritedRole')
                }
                SystemActions.displayErrorMessage(messageObject);
                return false;
            }
        }
        return true
    }

    private _rolesChanged = (roles: any[]) => {
        OrganizationActions.update("AssignedRoles", roles);
    }

    private _availableRoles = () => {
        var allRoles = this.state.allRoles;
        var assignedRoles = this.state.organization.AssignedRoles;

        var roles = allRoles.filter((role) => {
            return assignedRoles.filter((assignedRole) => {
                return role.ID === assignedRole.ID && role.Name === assignedRole.Name
            }).length === 0
        });
        return roles;
    }

    componentWillMount() {
        ListHelper.sort(this.state.allRoles, "Name");
        ListHelper.sort(this.state.organization.AssignedRoles, "Name");
    }

    componentWillUpdate(nextProps: OrganizationAccessRightFormProps, nextState: OrganizationAccessRightFormState) {
        ListHelper.sort(this.state.organization.AssignedRoles, "Name");
    }

    componentDidMount() {
        OrganizationStore.addChangeListener(this._loadState);
        SystemStore.addChangeListener(this._systemChange);
        window.addEventListener('beforeunload', this._checkForUnsavedChanges);

    }

    componentWillUnmount() {
        OrganizationStore.removeChangeListener(this._loadState);
        SystemStore.removeChangeListener(this._systemChange);
        window.removeEventListener('beforeunload', this._checkForUnsavedChanges);

    }

    render() {
        var inputObj = {
            className: 'form-control',
            type: 'text'
        }

        var Organization = this.state.organization;

        // Renaming of the roots is temporarily disabled (bug #11591)
        var editable = false;

        var OrganizationNameInput = {
            ...inputObj,
            name: 'Name',
            value: Organization.Name
        };

        var header = InovxLoader.t('organization:form.header');
        var nameFieldHeader = InovxLoader.t("organization:common.organizationName");

        if (Organization.InheritAccessRightFromID) {
            nameFieldHeader = InovxLoader.t("organization:common.workspace");
        }

        return (
            <InovxControls.StaticHeaderForm title={header} saveOnClick={this._saveOrganization} cancelOnClick={this._cancel}
                isActionInProgress={this.state.isActionInProgress} inProgressMessage={this.state.actionInProgressMsg} >

                <InovxControls.FormField title={`${nameFieldHeader}*`} inputName='Name'>
                    <InovxControls.RequiredInput {...OrganizationNameInput} onChangeCallback={this._onChange} ref="name" readOnly={!editable} />
                </InovxControls.FormField>

                <InovxControls.FormField title={InovxLoader.t("organization:common.roles") } inputName='Role'>
                    <span className="edit-role-description">{InovxLoader.t("organization:form.rolesDescription")}</span>
                </InovxControls.FormField>
                <InovxControls.ObjectAssignment
                    leftHeader={InovxLoader.t('organization:form.availableRoles') }
                    rightHeader={InovxLoader.t('organization:form.assignedRoles') }
                    availableObjects={this._availableRoles() }
                    assignedObjects={this.state.organization.AssignedRoles}
                    inheritedObjectAttribute={"Inherited"}
                    onValueChanged={this._rolesChanged}
                    validateRemove={this._validateRemove}
                />
            </InovxControls.StaticHeaderForm>
        );
    }
}

export default OrganizationAccessRightForm;
